import { render } from "./DrawerLayout.vue?vue&type=template&id=3f5420d9"
import script from "./DrawerLayout.vue?vue&type=script&lang=js"
export * from "./DrawerLayout.vue?vue&type=script&lang=js"

import "./DrawerLayout.vue?vue&type=style&index=0&id=3f5420d9&lang=scss"
script.render = render

export default script